<template lang="pug">
  .basic-campaign-info
    .row
      .col
        span {{ $t('供应商ID') }}:
        span {{ data.vendor_internal_id || '—' }}
      .col
        span {{ $t('成立时间') }}:
        span(v-if="data.establish_time") {{ data.establish_time + $t('年') }}
      .col
        span {{ $t('电话') }}:
        span {{ data.telephone }}
    .row
      .col
        span {{ $t('是否为总库供应商') }}:
        span {{ data.is_total_vendor ? $t('是') : $t('否') }}
      .col
        span {{ $t('是否有母公司') }}:
        span {{ data.parent_company ? data.parent_company_name : $t('否') }}
      .col
        span {{ $t('邮编') }}:
        span {{ data.zip_code }}

    .row
      .col
        span {{ $t('公司类型') }}:
        span {{ $t(companyTypeMap[data.company_type]) }}
      .col
        span {{ $t('地址') }}:
        span {{ data.address }}
</template>

<script>
import DisplayTextContainer from '@/components/DisplayTextContainer'

const companyTypeMap = {
  1: '非上市公司',
  2: '上市公司'
}

const companySizeMap = {
  1: '少于30人',
  2: '30-50人',
  3: '50-100人',
  4: '100-300人',
  5: '大于300人'
}
export default {
  components: {
    DisplayTextContainer
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      companyTypeMap,
      companySizeMap,
      showDialog: false,
      viewImg: {
        url: null,
        width: null,
        height: null
      }
    }
  },
  methods: {
    show (url) {
      const self = this
      this.viewImg.url = url
      let img = new Image()
      img.src = url
      img.addEventListener('load', function () {
        self.viewImg.height = this.naturalHeight
        self.viewImg.width = this.naturalWidth
        self.showDialog = true
      })
    }
  }
}
</script>

 <style lang="stylus">
.basic-campaign-info
  .row
    display flex
    margin-bottom 10px
    &:last-child
      justify-content space-between
    .col
      width 33.3%
      height 20px
      line-height 20px
      > span:nth-child(1)
        margin-right 10px
        color #262626
      > span:nth-child(2)
        color #595959

.basic-campaign-info__dialog
  .el-dialog
    width 500px
  .el-dialog__body
    display flex
    justify-content center
    align-items center
    .widthFixed
      width 400px
    .heightFixed
      height 400px
.basic-campaign-info__awards__item
  > span:nth-child(1)
    display: inline-block
    width: 150px
  > span:nth-child(2)
    color $main
    cursor pointer
    > i
      margin-right 10px
 </style>
